import React, { createContext, useState, useContext, useEffect } from 'react';

const CampaignContext = createContext();

export const useCampaigns = () => useContext(CampaignContext);

export const CampaignProvider = ({ children }) => {
  const [campaigns, setCampaigns] = useState(() => {
    const savedCampaigns = localStorage.getItem('campaigns');
    return savedCampaigns ? JSON.parse(savedCampaigns) : [];
  });

  useEffect(() => {
    localStorage.setItem('campaigns', JSON.stringify(campaigns));
  }, [campaigns]);

  const addCampaign = (newCampaign) => {
    setCampaigns(prevCampaigns => [{ ...newCampaign, id: Date.now(), currentAmount: 0 }, ...prevCampaigns]);
  };

  const updateCampaign = (updatedCampaign) => {
    setCampaigns(prevCampaigns => prevCampaigns.map(campaign => 
      campaign.id === updatedCampaign.id ? updatedCampaign : campaign
    ));
  };

  const deleteCampaign = (campaignId) => {
    setCampaigns(prevCampaigns => prevCampaigns.filter(campaign => campaign.id !== campaignId));
  };

  return (
    <CampaignContext.Provider value={{ campaigns, addCampaign, updateCampaign, deleteCampaign }}>
      {children}
    </CampaignContext.Provider>
  );
};